import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDreamteam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1185_132416)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
			fill: "white",
			stroke: "#0050FF"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M22.13 26L16 21.5L9.75 26L11.88 18.5L6 13.63L13.5 13.38L16 6L18.5 13.5L26 13.75L20 18.5L22.13 26Z",
			fill: "#0050FF"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1185_132416",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgDreamteam;
